'use strict';

import {
    ApplicationInsights
} from '@microsoft/applicationinsights-web';

export var configService = function ($http, $q) {

    var appSettings;

    var getDataCenter = function (ticketId) {
        return getAppSettings().then(settings => {
            return $http({
                url: `${settings.apiUrl}config/datacenter/${ticketId}`,
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                }
            }).then(res => {
                return res.data;
            });
        });
    }

    var getAppSettings = function () {
        var deferred = $q.defer();

        if (appSettings) {
            deferred.resolve(appSettings);
        } else {
            $http.get('/settings').then(res => {
                appSettings = res.data;
                deferred.resolve(appSettings);
            });
        }
        return deferred.promise;
    }

    var getActivityConfig = function(ticketId) {
        return getAppSettings().then((settings) => {
            return $http({
                url: `${settings.apiUrl}config/activity`,
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                }
            }).then((res) => {
                return res.data;
            })
        });
    }

    return {
        getDataCenter: getDataCenter,
        getAppSettings: getAppSettings,
        getActivityConfig: getActivityConfig
    };
};

configService.$inject = ['$http', '$q'];